import React, { useMemo } from "react";

const rand = (a, b) => a + Math.random() * (b - a);

export const HeroFx = () => {
  const particles = useMemo(() => Array.from({ length: 22 }, (_, i) => ({ id: i, left: rand(0, 100), top: rand(35, 100), dur: rand(9, 18), delay: rand(0, 12), size: rand(2, 4) })), []);
  const beams = useMemo(() => Array.from({ length: 6 }, (_, i) => ({ id: i, left: 8 + i * 16 + rand(-4, 4), delay: rand(0, 3.4), dur: rand(2.6, 4.2) })), []);
  const lines = useMemo(() => Array.from({ length: 5 }, (_, i) => ({ id: i, top: 18 + i * 14 + rand(-3, 3), delay: rand(0, 2.8), dur: rand(2.2, 3.6) })), []);
  return (
    <div className="hero-fx" aria-hidden="true" data-testid="hero-fx">
      <div className="headlight" style={{ left: "-8%", top: "10%", background: "radial-gradient(circle, rgba(255,255,255,0.55), rgba(226,232,240,0.15) 45%, transparent 70%)" }} />
      <div className="headlight" style={{ right: "-10%", top: "0%", animationDelay: "3s", background: "radial-gradient(circle, rgba(224,31,31,0.75), rgba(224,31,31,0.2) 45%, transparent 70%)" }} />
      {beams.map((b) => <span key={b.id} className="beam" style={{ left: `${b.left}%`, animationDelay: `${b.delay}s`, animationDuration: `${b.dur}s` }} />)}
      {lines.map((l) => <span key={l.id} className="speedline" style={{ top: `${l.top}%`, animationDelay: `${l.delay}s`, animationDuration: `${l.dur}s` }} />)}
      {particles.map((p) => <span key={p.id} className="particle" style={{ left: `${p.left}%`, top: `${p.top}%`, width: p.size, height: p.size, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s` }} />)}
    </div>
  );
};

export default HeroFx;
